import { SmartfireComponent } from "@smartfire/gutenberg-react";
import { registerFormatType, applyFormat, removeFormat, getActiveFormat } from "@wordpress/rich-text";
import { InspectorControls } from '@wordpress/block-editor';
import {GradientPicker, PanelBody, PanelRow} from '@wordpress/components';
import { gradientPalette } from "../theme/product/palettes/gradientPalette";
const __ = SmartfireComponent.__;

export default function gradients(){
    [
        {
            name: 'gradient',
            title: __('Text gradient color')
        }
    ].forEach(({ name, title }) => {
        const type = `advanced/${name}`

        registerFormatType(type, {
            title,
            tagName: 'span',
            className: name,
            attributes: {
                style: 'style'
            },
            edit({ isActive, value, onChange }) {
                let activeColor

                if (isActive) {
                    const activeFormat = getActiveFormat(value, type)
                    const style = activeFormat.attributes.style

                    activeColor = style.replace(new RegExp(`^background:\\s*`), '')
                    activeColor = activeColor.replace(';-webkit-background-clip:text;-webkit-text-fill-color:transparent', '')
                }

                return (
                    <InspectorControls>
                        <PanelBody title={"Gradient color text"} initialOpen={false}>
                            <PanelRow>
                                <GradientPicker
                                    value={activeColor}
                                    onChange={(gradient) => gradient ? onChange(applyFormat(value, {
                                        type,
                                        attributes: {
                                            style: `background:${gradient};-webkit-background-clip:text;-webkit-text-fill-color:transparent`
                                        }
                                    })) : onChange(removeFormat(value, type))}
                                    gradients={gradientPalette}
                                />
                            </PanelRow>
                        </PanelBody>
                    </InspectorControls>
                )
            }
        })
    })
};
